export enum MappingSources {
    documentAttributes,
    firstInstallment,
    totalAward
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/infrastructure/model/enum/mappingSources.enum.ts